import { create } from 'zustand';

import { CreateDoBoxFormStore } from './types';

export const useCreateDoBoxFormStore = create<CreateDoBoxFormStore>((set) => ({
  isOpen: false,
  isAiAssistantOpen: false,
  taskSubgroupId: null,
  open: (options) =>
    set({
      isOpen: true,
      isAiAssistantOpen: false,
      taskSubgroupId: options?.taskSubgroupId ?? null,
    }),
  close: () => set({ isOpen: false, taskSubgroupId: null }),
  openAiAssistant: (options) =>
    set({
      isOpen: false,
      isAiAssistantOpen: true,
      taskSubgroupId: options?.taskSubgroupId ?? null,
    }),
  // Must keep taskSubgroupId: AiAssistantDialog closes before onResult, and the form reapplies the section.
  closeAiAssistant: () => set({ isAiAssistantOpen: false }),
}));
